export const HOMEPAGE_LINK_TITLE = "Homepage of SundaeSwap - The Decentralized Exchange on Cardano";
export const TARGET_BLANK = {
  rel: "external noopener noreferrer",
  target: "_blank",
};
